import { useState } from 'react';
import { createPortal } from 'react-dom';
import './table/EditorTable.css';

function MovePlantillaModal({
    plantillaName,
    folders,
    currentFolderId,
    onMove,
    onClose,
}) {
    const [selectedId, setSelectedId] = useState(currentFolderId);

    const sortedFolders = [...(folders || [])].sort((a, b) =>
        (a.sort_order || 0) - (b.sort_order || 0) || a.nom.localeCompare(b.nom)
    );

    const handleConfirm = () => {
        if (selectedId === currentFolderId) return;
        onMove(selectedId);
    };

    const itemClass = (id) => {
        let cls = 'mvfolder-item';
        if (selectedId === id) cls += ' mvfolder-item--selected';
        if (currentFolderId === id) cls += ' mvfolder-item--disabled';
        return cls;
    };

    return createPortal(
        <div className="mvfolder-overlay" onClick={onClose}>
            <div className="mvfolder-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="mvfolder-header">
                    <span className="mvfolder-title">Moure &ldquo;{plantillaName}&rdquo; a carpeta</span>
                    <button className="mvfolder-close-btn" onClick={onClose}>&times;</button>
                </div>

                <div className="mvfolder-body">
                    <div
                        className={itemClass(null)}
                        onClick={() => currentFolderId !== null && setSelectedId(null)}
                    >
                        Sense carpeta (arrel)
                    </div>

                    {sortedFolders.map(folder => (
                        <div
                            key={folder.id}
                            className={itemClass(folder.id)}
                            onClick={() => currentFolderId !== folder.id && setSelectedId(folder.id)}
                        >
                            {folder.nom}
                        </div>
                    ))}
                </div>

                <div className="mvfolder-footer">
                    <button className="mvfolder-btn-cancel" onClick={onClose}>
                        Cancel·la
                    </button>
                    <button
                        className="mvfolder-btn-confirm"
                        onClick={handleConfirm}
                        disabled={selectedId === currentFolderId}
                    >
                        Moure
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default MovePlantillaModal;
